export type InputVariant = "standard" | 'filled' | "outlined"

export enum PasswordStrengthLabel {
    'Too weak' = 0,
    Weak = 1 ,
    Fair = 2,
    Good = 3,
    Excellent = 4
}

export enum PasswordStrengthColor {
    '#8b0000' = 0,
    '#ff4500' = 1 ,
    'orange ' = 2,
    '#9acd32' = 3,
    'green' = 4
}
